interface ProgressBarProps {
  done: number;
  total: number;
  /** Thin bars are used inline in group headers, thick in the stats bar. */
  size?: 'sm' | 'md';
  label?: string;
}

export function ProgressBar({ done, total, size = 'md', label }: ProgressBarProps) {
  const percent = total === 0 ? 0 : (done / total) * 100;
  const complete = total > 0 && done === total;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-xs bg-line ${size === 'sm' ? 'h-1' : 'h-2'}`}
      role="progressbar"
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
      {...(label ? { 'aria-label': label } : {})}
    >
      <div
        className={`h-full transition-[width] duration-200 ease-out ${
          complete ? 'bg-pip' : 'bg-pip-dim'
        }`}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
